import React from "react";

function PendingApprovalSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g
          id="Group_9770"
          data-name="Group 9770"
          transform="translate(-1013 -357.5)"
        >
          <path
            id="Path_40247"
            data-name="Path 40247"
            d="M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
            transform="translate(1013 357.5)"
            fill="#d7242e"
            opacity="0.06"
          />
          <g id="pending_black_24dp" transform="translate(1021 366)">
            <g id="Group_8578" data-name="Group 8578">
              <rect
                id="Rectangle_14183"
                data-name="Rectangle 14183"
                width="24"
                height="24"
                fill="none"
              />
            </g>
            <g id="Group_8580" data-name="Group 8580">
              <g id="Group_8579" data-name="Group 8579">
                <path
                  id="Path_40085"
                  data-name="Path 40085"
                  d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                  fill="#d7242e"
                />
                <circle
                  id="Ellipse_3069"
                  data-name="Ellipse 3069"
                  cx="1.5"
                  cy="1.5"
                  r="1.5"
                  transform="translate(5.5 10.5)"
                  fill="#d7242e"
                />
                <circle
                  id="Ellipse_3070"
                  data-name="Ellipse 3070"
                  cx="1.5"
                  cy="1.5"
                  r="1.5"
                  transform="translate(10.5 10.5)"
                  fill="#d7242e"
                />
                <circle
                  id="Ellipse_3071"
                  data-name="Ellipse 3071"
                  cx="1.5"
                  cy="1.5"
                  r="1.5"
                  transform="translate(15.5 10.5)"
                  fill="#d7242e"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default PendingApprovalSvgComponent;
